export var AuthMethod;
(function (AuthMethod) {
    AuthMethod["SameDevice"] = "SameDevice";
    AuthMethod["QrCode"] = "QrCode";
})(AuthMethod || (AuthMethod = {}));
export var AuthStatus;
(function (AuthStatus) {
    AuthStatus["Pending"] = "pending";
    AuthStatus["Failed"] = "failed";
    AuthStatus["Complete"] = "complete";
    AuthStatus["Unknown"] = "unknown";
})(AuthStatus || (AuthStatus = {}));
